angular.module('sodCustomActionsLib', ['sodDocumentLibrary', 'sodAppointmentSelector', 'sodNotificationCenter', 'sod.helper']);